<mat-progress-bar mode="indeterminate" class="sign-in-select-profile-loader" *ngIf="loading"></mat-progress-bar>
<h2 class="sign-in-select-profile-title">{{ 'SIGN_IN.SELECT_PROFILE' | translate }}</h2>
<ul class="sign-in-select-profile-entities">
  <li class="sign-in-select-profile-entity" *ngFor="let bpByEntity of bpByEntities">
    <div fxLayout="row" fxLayoutAlign="start center">
      <span class="sign-in-select-profile-entity-name">{{ bpByEntity.entityName }}</span>
      <hr class="sign-in-select-profile-line">
    </div>
    <ul class="sign-in-select-profile-business-profiles">
      <li class="sign-in-select-profile-business-profile" *ngFor="let businessProfile of bpByEntity.businessProfiles">
        <button class="sign-in-select-profile-button" mat-button (click)="selectBusinessProfile(businessProfile)">{{ businessProfile.name }}</button>
      </li>
    </ul>
  </li>
</ul>
